var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModuleHassadOffers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-module-hassad-offers",
    transform: "translate(-31.92 0.08)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5839",
    "data-name": "Rectangle 5839",
    width: 92,
    height: 92,
    transform: "translate(31.92 -0.08)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "offers",
    transform: "translate(45.12 22.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40862",
    "data-name": "Path 40862",
    d: "M66.552,41.651v2.856A2.864,2.864,0,0,1,63.7,47.362H5.156A2.864,2.864,0,0,1,2.3,44.507V5.956A2.864,2.864,0,0,1,5.156,3.1H28",
    transform: "translate(-2.3 -1.672)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40863",
    "data-name": "Path 40863",
    d: "M28.3,3.1H52.573a2.864,2.864,0,0,1,2.856,2.856V30.229",
    transform: "translate(8.823 -1.672)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40864",
    "data-name": "Path 40864",
    d: "M39.289,10.667,30.723,2.1H19.3L33.578,16.378",
    transform: "translate(4.973 -2.1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40865",
    "data-name": "Path 40865",
    d: "M37.3,21.811,53.006,37.517V26.095L43.011,16.1",
    transform: "translate(12.674 3.889)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40866",
    "data-name": "Path 40866",
    d: "M38.295,7.1,41.15,9.956h4.283v4.283l2.856,2.856L45.434,19.95v4.283H41.15l-2.856,2.856-2.856-2.856H31.156V19.95L28.3,17.095l2.856-2.856V9.956h4.283Z",
    transform: "translate(8.823 0.039)",
    fill: "#00af9a",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40867",
    "data-name": "Path 40867",
    d: "M12.583,21.667H11.156A2.864,2.864,0,0,1,8.3,18.811V15.956A2.864,2.864,0,0,1,11.156,13.1h1.428a2.864,2.864,0,0,1,2.856,2.856v2.856A2.864,2.864,0,0,1,12.583,21.667Z",
    transform: "translate(0.267 2.606)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40868",
    "data-name": "Path 40868",
    d: "M21.583,30.667H20.156A2.864,2.864,0,0,1,17.3,27.811V24.956A2.864,2.864,0,0,1,20.156,22.1h1.428a2.864,2.864,0,0,1,2.856,2.856v2.856A2.864,2.864,0,0,1,21.583,30.667Z",
    transform: "translate(4.117 6.456)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    "data-name": "Line 121",
    x1: 18.358,
    y2: 20.397,
    transform: "translate(10.403 16.726)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleHassadOffers);
export default __webpack_public_path__ + "static/media/icon-module-hassad-offers.bdb716c9.svg";
export { ForwardRef as ReactComponent };